import React, { PropsWithChildren, ReactElement } from 'react';

import { CosmicPageClient } from '../Cosmic/cosmicPageClient';

import { PageFetcherProvider } from './PageFetcherProvider';

export interface ICosmicPageClientProviderProps extends PropsWithChildren<any> {
    bucket: string;
}

export function CosmicPageClientProvider (props: ICosmicPageClientProviderProps): ReactElement {
    const { children, bucket }: PropsWithChildren<any> = props;

    const client: CosmicPageClient = new CosmicPageClient({
        bucket,
    });

    return (
        <PageFetcherProvider fetcher={client}>
            {children}
        </PageFetcherProvider>
    );
}
